import React, { createContext, useContext } from 'react';
import { setApiKey } from '@/lib/googlePlaces';

// The browser Maps key is a build-time value now.
//
// It used to be fetched at startup from a getGoogleMapsKey function, which
// bought nothing: the Maps JS API is client-side by design, so the key reaches
// the browser either way and is protected by HTTP referrer restrictions in the
// Google Cloud console. Removing the round trip removes a startup step and a
// failure mode. The Places *server* key is a different, genuinely secret key
// held by the searchPlaces Edge Function.

const key = import.meta.env.VITE_GOOGLE_MAPS_BROWSER_KEY ?? '';
if (key) setApiKey(key);

// Components still gate on `status`: the script load itself can fail, and
// MapView / CafeInfo keep their "Map unavailable" fallback for that.
const MapsKeyContext = createContext({ status: key ? 'ready' : 'error' });

export const MapsKeyProvider = ({ children }) => (
  <MapsKeyContext.Provider value={{ status: key ? 'ready' : 'error' }}>
    {children}
  </MapsKeyContext.Provider>
);

export const useMapsKey = () => useContext(MapsKeyContext);
